import Glide from '@glidejs/glide';
import { Autoplay } from '@glidejs/glide/dist/glide.modular.esm';
import '@glidejs/glide/dist/css/glide.core.min.css';

document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.glide.contrasts');
    if (!slider) return;

    const glide = new Glide(slider, {
        type: 'carousel',
        startAt: 0,
        focusAt: 'center',
        perView: 4,         // 2 cartes pleines + un bout de la suivante
        gap: 16,
        autoplay: false,
        hoverpause: false,
        animationDuration: 800,
        breakpoints: {
            1023: {
                perView: 1.8,
                focusAt: 'center',
            },
            767: {
                perView: 1.5,
                autoplay: false, // Désactiver autoplay sur mobile, utiliser les contrôles
            }
        }
    });

    glide.mount({ Autoplay });
});
